// 单文件引入方式

import SwitchField from './ZuiSwitchField.vue'

export default {
  install(Vue) {
    Vue.component('ZuiSwitchField', SwitchField)
  }
}

export { SwitchField }
